import React, { useContext, useEffect, useState } from 'react';
import { FilterContext } from "../context/filterContext";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { IoClose } from "react-icons/io5";
import { useTranslation } from 'react-i18next';

interface Modal {
    isOpen: any,
    onClose:any,
    value:any,
    index:any,
    title:any,
    onSubmit:any
}

const Modal:React.FC<Modal> = ({ isOpen, onClose, value, index, title,onSubmit }) => {
  const {
    propertyType,
    setPropertyType,
    bedrooms,
    setBedrooms,
    bathrooms,
    setBathrooms,
    parking,
    setParking,
    price,
    setPrice,
    status,
    setStatus,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice
  } = useContext(FilterContext);
  const [property, setProperty] = useState('All Property Types');
  const handleRangeChange = (value:any) => {
    setPrice(value);
  };

   useEffect(() => {
          if (isOpen) {
              const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
              document.body.style.overflow = 'hidden';
              document.body.style.paddingRight = `${scrollbarWidth}px`; // Add padding equal to scrollbar width
          } else {
              document.body.style.overflow = '';
              document.body.style.paddingRight = ''; // Reset padding
          }
  
          return () => {
              document.body.style.overflow = '';
              document.body.style.paddingRight = ''; // Cleanup
          };
      }, [isOpen]);

   const {t}=useTranslation();
    const propertiesOption = [
      { id: 1, name: t('propertyFilter.all'), key: 'all' },
      { id: 2, name: t('propertyFilter.home'), key: ['CH','ME','MEM','MM','MPM','PP'] },
      { id: 2, name: t('propertyFilter.condos'), key: ['CC','CI','AP','LS'] },
      { id: 2, name: t('propertyFilter.land'), key: ['TB','TV'] },
    ];

  if (!isOpen) return null;

  const clearFilters = () => {
    setPropertyType({ id: 1, name: 'All Property Types', key: 'all' });
    setPrice([0,320000]);
    setBedrooms('');
    setBathrooms('');
  };
  const selectPropertyType = (item:any) => {
    propertiesOption.map((property) => {
        if (property.id === item.id) {
            setProperty(property.name);
            setPropertyType(property.key);
        }
    });
};
const handleAfterChange = (value:any) => {
    setMinPrice(value[0]);
    setMaxPrice(value[1]);
};
  const handleSubmit = () => {
    onSubmit('true');
    onClose()
};

  return (
    <>
      {title === 'filter' && (
  <div className="fixed inset-0 z-[2000] flex items-center justify-center  bg-black bg-opacity-50 px-4" style={{margin:"0"}}>
    <div className="bg-white rounded-lg shadow-lg max-h-[90vh] w-full max-w-3xl relative">
      {/* Header */}
      <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
        <h2 className="text-2xl font-semibold text-gray-800">{t('filter.filters')}</h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700 transition duration-150"
        >
          <IoClose size={24} />
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="overflow-y-auto px-6 py-4 space-y-6 max-h-[65vh]">
        {/* Property Types */}
        <div>
          <h3 className="font-semibold text-gray-700 mb-2">{t('filter.type')}</h3>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
            {propertiesOption.map(type => (
              <button
                key={type.id}
                className={`p-2 border rounded-md transition duration-150 ${
                  propertyType.name === type.name ? 'bg-pantone288-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                }`}
                onClick={() => setPropertyType(type)}
              >
                {type.name}
              </button>
            ))}
          </div>
        </div>

        {/* Bedrooms, Bathrooms, Parking */}
        <div className="grid grid-cols-1 items-center gap-6">
          <div>
            <h3 className="font-semibold text-gray-700 mb-2">{t('filter.bedrooms')}</h3>
            <div className="flex space-x-2 justify-center">
              {[t('collectionTypes.all'), '1', '2', '3', '4', '5+'].map(num => (
                <button
                  key={num}
                  className={`p-3 border rounded-full w-12 transition duration-150 flex items-center justify-center ${
                    bedrooms === num ? 'bg-pantone288-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                  }`}
                  onClick={() => setBedrooms(num)}
                >
                  {num}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-700 mb-2">{t('filter.bathrooms')}</h3>
            <div className="flex space-x-2 justify-center item">
              {[t('collectionTypes.all'), '1', '2', '3', '4', '5+'].map(num => (
                <button
                  key={num}
                  className={`p-3 border rounded-full w-12 transition duration-150 flex items-center justify-center ${
                    bathrooms === num ? 'bg-pantone288-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                  }`}
                  onClick={() => setBathrooms(num)}
                >
                  {num}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-700 mb-2">{t('filter.parking')}</h3>
            <div className="flex space-x-2 justify-center">
              {[1, 2, 3, 4, 5].map(num => (
                <button
                  key={num}
                  className={`p-3 border rounded-full w-12 transition duration-150 ${
                    parking === num ? 'bg-pantone288-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                  }`}
                  onClick={() => setParking(num)}
                >
                  {num}+
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Price Range */}
        <div>
          <h3 className="font-semibold text-gray-700 mb-2">{t('filter.price')}</h3>
          <Slider
            range
            min={0}
            max={3200000}
            value={price}
            onChange={handleRangeChange}
            onChangeComplete={handleAfterChange}
            className="w-full h-2 mb-4 rounded-lg appearance-none cursor-pointer"
          />
          <div className="flex justify-between text-gray-600">
            <span>${price[0].toLocaleString()}</span>
            <span>${price[1].toLocaleString()}</span>
          </div>
        </div>

        {/* Square Footage */}
        {/* <div>
          <h3 className="font-semibold text-gray-700 mb-2">Square Footage (sqft)</h3>
          <Slider
            range
            min={0}
            max={8000}
            value={sqft}
            onChange={handleSqftChange}
            className="w-full h-2 mb-4 rounded-lg appearance-none cursor-pointer"
          />
          <div className="flex justify-between text-gray-600">
            <span>{sqft[0]} sqft</span>
            <span>{sqft[1]}+ sqft</span>
          </div>
        </div> */}

      </div>

      {/* Fixed Footer */}
      <div className="flex justify-between items-center p-4 border-t border-gray-200">
        <button
          className="px-4 py-2 bg-pantone288-600 text-white rounded-md hover:bg-pantone288-500 transition duration-150"
          onClick={handleSubmit}
        >
          {t('filter.apply')}
        </button>
        <button
          className="px-4 py-2 bg-gray-300 rounded-md hover:bg-pantone288-600 hover:text-white transition duration-150"
          onClick={clearFilters}
        >
          {t('filter.clear')}
        </button>
      </div>
    </div>
  </div>
)}



      {/* {title === 'imageDialog' && (
        <div className="fixed inset-0 overflow-hidden z-50 flex items-center justify-center bg-black bg-opacity-80">
          <div className="bg-Stone-600 overflow-auto  rounded-lg w-full h-full px-5 relative flex flex-col">
            <div className="flex-grow">
              <ImageSlider images={value} initialIndex={index} />
            </div>
            <button
              onClick={onClose}
              className="absolute top-3 right-4 bg-Indigo-700/40 p-3 font-bold text-white py-2 px-4 rounded"
            >
              X
            </button>
          </div>
        </div>
      )} */}
    </>
  );
};

export default Modal;